import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

import ReadMore from '../../ReadMore/ReadMore';

function PostDescription({ content, readMore = false, subtitle = null }: any) {
  return (
    <div data-testid="post-description">
      <Box sx={{ mb: 3 }}>
        {subtitle && (
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: 'bold',
            }}
          >
            {subtitle}
          </Typography>
        )}

        <ReadMore content={content} expand={!readMore} />
      </Box>
    </div>
  );
}

PostDescription.propTypes = {
  parent: PropTypes.object,
  subtitle: PropTypes.string,
  content: PropTypes.string.isRequired,
  readMore: PropTypes.bool,
};

export default PostDescription;
